module.exports = __webpack_public_path__ + "static/img/contact-administrator-ico.c2da43ac.png";